import { create } from 'zustand'

import { webApp } from '@shared'

import { createSelectors } from './helpers'

export enum PrologueStage {
  BeforeSpiral = 'beforeSpiral',
  Eye = 'eye',
  Finished = 'finished',
}

interface AppStore {
  isLoading: boolean
  isUserProgressVisible: boolean
  isTapsVisible: boolean
  isInventoryVisible: boolean
  stars: number
  taps: number
  prologueStage: PrologueStage
  showTooltips: boolean
  step: number | null
  actions: {
    setUserProgressVisible: (isStarsVisible: boolean) => void
    setTapsVisible: (isTapsVisible: boolean) => void
    setInventoryVisible: (isInventoryVisible: boolean) => void
    setStars: (stars: number) => void
    setTaps: (taps: number) => void
    incrementStars: () => void
    decrementStars: () => void
    incrementTaps: () => void
    decrementTaps: () => void
    setPrologueStage: (stage: PrologueStage) => void
    setIsLoading: (isLoading: boolean) => void
    setShowTooltips: (showTooltips: boolean) => void
    setStep: (step: number) => void
    nextStep: () => void
  }
}

export const usePrologueStoreBase = create<AppStore>((set, get) => ({
  isLoading: false,
  showTooltips: false,
  isUserProgressVisible: false,
  isTapsVisible: false,
  isInventoryVisible: false,
  stars: 0,
  taps: 99,
  prologueStage: PrologueStage.BeforeSpiral,
  step: null,
  actions: {
    setStep: (step: number) => {
      set({ step })
    },
    nextStep: () => {
      set((state) => ({
        step: state.step !== null ? state.step + 1 : null,
      }))
      webApp.HapticFeedback.impactOccurred('soft')
    },
    setUserProgressVisible: (isUserProgressVisible: boolean) =>
      set({ isUserProgressVisible }),
    setTapsVisible: (isTapsVisible: boolean) => set({ isTapsVisible }),
    setInventoryVisible: (isInventoryVisible: boolean) => set({ isInventoryVisible }),
    setStars: (stars: number) => set({ stars }),
    setTaps: (taps: number) => set({ taps }),
    incrementStars: () => set((state) => ({ stars: state.stars + 1 })),
    decrementStars: () => set((state) => ({ stars: state.stars - 1 })),
    incrementTaps: () => set((state) => ({ taps: state.taps + 1 })),
    decrementTaps: () => set((state) => ({ taps: state.taps - 1 })),
    setPrologueStage: (prologueStage: PrologueStage) => set({ prologueStage }),
    setIsLoading: (isLoading) => set(() => ({ isLoading })),
    setShowTooltips: (showTooltips: boolean) => set({ showTooltips }),
  },
}))

export const usePrologueActions = () =>
  usePrologueStoreBase((state) => state.actions)
export const usePrologueIsLoadingState = () =>
  usePrologueStoreBase((state) => state.isLoading)
export const usePrologueStepState = () =>
  usePrologueStoreBase((state) => state.step)

export const usePrologue = createSelectors(usePrologueStoreBase)
